// Conexión de solo lectura al sistema de ventas (otro proyecto de Firebase), donde los locatarios
// registran su venta diaria. Se usa como segunda app con su propia sesión: inicia sesión quien
// tenga cuenta en ese sistema. Incluso en modo emulador apunta al sistema real, porque solo se lee.
import { firebase } from "@/config/firebase";

const NOMBRE_APP = "sistema-ventas";

const getEnv = (key: string, fallback: string): string =>
  typeof process.env[key] !== "undefined" && process.env[key] !== "" ? (process.env[key] as string) : fallback;

// Configuración web pública del proyecto sistema-ventas (la misma que publica su sitio).
const CONFIG = {
  apiKey: getEnv("VUE_APP_VENTAS_API_KEY", "AIzaSyDo-YdLs7QHpn4vP286AKNfYNz9VDfJAN4"),
  authDomain: getEnv("VUE_APP_VENTAS_AUTH_DOMAIN", "sistema-ventas-b53ba.firebaseapp.com"),
  projectId: getEnv("VUE_APP_VENTAS_PROJECT_ID", "sistema-ventas-b53ba"),
  storageBucket: getEnv("VUE_APP_VENTAS_STORAGE_BUCKET", "sistema-ventas-b53ba.firebasestorage.app"),
  messagingSenderId: getEnv("VUE_APP_VENTAS_MESSAGING_SENDER_ID", "506886979421"),
  appId: getEnv("VUE_APP_VENTAS_APP_ID", "1:506886979421:web:0db97518774536a1bd72b4"),
};

export function appVentas(): firebase.app.App {
  return firebase.apps.find((a) => a.name === NOMBRE_APP) || firebase.initializeApp(CONFIG, NOMBRE_APP);
}

/** Espera a que la sesión guardada del sistema de ventas se restaure (null si no hay). */
export function usuarioVentas(): Promise<firebase.User | null> {
  const auth = appVentas().auth();
  return new Promise((resolve) => {
    const fin = auth.onAuthStateChanged((u) => {
      fin();
      resolve(u);
    });
  });
}
